var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_12152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1002 15.8C11.9002 15.8 11.7002 15.8 11.4002 15.7C8.90023 15.2 6.40023 13.8 4.30023 11.7C2.20023 9.6 0.800234 7.1 0.300234 4.6C0.100234 3.5 0.400234 2.3 1.20023 1.5L1.80023 1C2.80023 0 4.30023 0 5.30023 1L6.30023 2C6.70023 2.4 6.90023 2.9 6.90023 3.5C6.90023 4 6.70023 4.6 6.20023 5L5.50023 5.5C6.00023 6.5 6.70023 7.6 7.50023 8.4C8.40023 9.3 9.40023 10 10.4002 10.4L11.1002 9.7C11.9002 9 13.3002 9 14.0002 9.8L15.0002 10.8C15.5002 11.3 15.7002 11.9 15.7002 12.5C15.7002 13.2 15.4002 13.8 15.0002 14.2L14.4002 14.8C13.8002 15.4 13.0002 15.8 12.1002 15.8ZM3.50023 1.8C3.30023 1.8 3.00023 1.8 2.90023 2L2.30023 2.6C1.90023 3 1.70023 3.7 1.80023 4.3C2.20023 6.5 3.50023 8.7 5.40023 10.6C7.30023 12.5 9.50023 13.8 11.7002 14.2C12.4002 14.3 13.0002 14.1 13.5002 13.7L14.1002 13.1C14.5002 12.7 14.5002 12.1 14.1002 11.8L13.1002 10.8C12.9002 10.6 12.6002 10.6 12.4002 10.8L11.6002 11.6C11.2002 12 10.6002 12.1 10.1002 11.9C8.90024 11.4 7.70023 10.5 6.60023 9.5C5.60023 8.5 4.80023 7.3 4.20023 6.1C3.90023 5.5 4.00023 4.9 4.40023 4.5L5.10023 3.8C5.20023 3.7 5.30023 3.5 5.30023 3.4C5.30023 3.3 5.30023 3.1 5.20023 3L4.20023 2C4.00023 1.8 3.80023 1.8 3.50023 1.8Z",
    className: "icon-fill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_12152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.97e8cfcc015e840fc070274db2d54304.svg";
export { ForwardRef as ReactComponent };